import manifest from '@shared/skills/manifest.json';

export interface ManifestSkill {
  id: string;
  name: string;
  tier: number;
  summary: string;
  primary_phases?: string[];
  ui_attachment?: string;
  locked_until_phase?: string | null;
  workers?: string[];
  moksha_skill?: string | null;
}

export interface SkillsManifest {
  version: string;
  skills: ManifestSkill[];
}

export const SKILLS_MANIFEST = manifest as SkillsManifest;

const skillById = new Map(SKILLS_MANIFEST.skills.map((s) => [s.id, s]));

export function manifestSkill(id: string): ManifestSkill | undefined {
  return skillById.get(id);
}
